import thankYou from '../assets/img/thank.png'
import React,{useEffect} from 'react';
import { useLocation } from 'react-router-dom';
function ThankYou(){
    const {pathname} = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return(
        <section className="pt-4">
        <div className="container">
            <div className="row align-items-center mt-0 mt-md-4">
                <div className="col-sm-6 mb-4 mb-lg-0">
                    <div className="thank mb-3">
                        <span className="thank-title-top">Order placed</span>
                        <h2 className="thank-title text-dark ">Successfully</h2>
                        <p className="thank-desc">Thank you for your purchase. Your order has been confirmed and is being processed. You will receive a confirmation email with details shortly.</p>
                    </div>
                    {/* <a className="btn btn-primary btn-medium rounded">
                        <i className="ti-angle-left"></i> Track Your Order </a> */}
                </div>
                <div className="col-md-5 d-lg-block d-none offset-lg-1 text-md-center">
                    <img className="img-fluid" src={thankYou} alt="thank"/>
                </div>
            </div>
        </div>
    </section>
    );
}
export default ThankYou;